<template>     
  <v-menu offset-y v-if="(isOperator || isSysAdmin) && (enseignes.length > 1 || selectedFilterEnsIds)"  >
    <v-btn slot="activator" class="text-none" flat >{{selectedFilterEnsIds == undefined?$t('Pilot.MissionDrawer.WholeFleet'):(dicEnseigne && dicEnseigne[selectedFilterEnsIds])?dicEnseigne[selectedFilterEnsIds].ENS_LIBELLE:''}} <v-icon class="ml-2">mdi-chevron-down</v-icon></v-btn>
    <v-list style="overflow: auto; max-height: 600px;">     
      <v-list-tile :class="{'primary white--text':selectedFilterEnsIds == undefined}" @click="$store.myActions.MISSION_SET_ENSEIGNE_FILTER([]);">             
          <v-list-tile-title><strong>{{ $t('Pilot.MissionDrawer.WholeFleet') }}</strong></v-list-tile-title>            
      </v-list-tile>            
        <v-list-tile v-for="enseigne in enseignes" :key="enseigne.ENS_ID" :class="{'primary white--text':enseigne.id == selectedFilterEnsIds}" @click="$store.myActions.MISSION_SET_ENSEIGNE_FILTER([enseigne.ENS_ID]);">             
          <v-list-tile-title>{{ enseigne.ENS_LIBELLE }}</v-list-tile-title>            
      </v-list-tile>   
    </v-list>  
  </v-menu>    
</template>
<script>  
import { toNumberDictionary } from '@/utils/groupBy'
import { mapGetters } from 'vuex'  
  export default {
   name: 'MissionOperatorFilter',       
   computed: {
       ...mapGetters([                  
         'missions',
         'filterMission',      
         'isOperator',
         'isSysAdmin',
         'userProfile'
      ]),      
      selectedFilterEnsIds :{
          get() {
            return this.filterMission?.ensIds?.at(0) ?? undefined
          },
          set(newValue) {                        
            this.$store.myActions.MISSION_SET_ENSEIGNE_FILTER(newValue?[newValue]:[])
          }
      },
      dicEnseigne(){
        return this.$store.myGetters.enseignesById // toNumberDictionary(this.missions?.map(m => { return  {id:m.ensId,key:m.ensLibelle}}) ?? [],e => e.id)
      },
      enseignes() {   
        return this.$store.myGetters.enseignes
        //return Object.keys(this.dicEnseigne)?.map(strId => this.dicEnseigne[Number.parseInt(strId)])?.sort((a, b) => (a.key > b.key) ? 1 : -1)  ?? []
      }
    },
    created()
    {
      if(this.isOperator || this.isSysAdmin) {
        this.$store.myActions.ENSEIGNE_ENSURE_LIST()
      }
    },
    mounted(){          
      if(!this.filterMission.hasSetEnsids && (this.isOperator || this.isSysAdmin)) this.$store.myActions.MISSION_SET_ENSEIGNE_FILTER([this.userProfile.ensId])
    },
    methods: {      
      toggleDdlEnseigne(){        
        if(!this.$refs.ddlEnseigne.isFocused) this.$refs.ddlEnseigne.onClick()
        else {
          this.$refs.ddlEnseigne.isFocused = false
          this.$refs.ddlEnseigne.isMenuActive = false
        }
      }
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  
</style>
